<template>
  <div class="container">
    <div class="info">
      <div class="title">Станьте заметнее для путешественников</div>
      <div class="subtitle">
        Поделитесь интересным фактом про достопримечательность — это покажет вашу экспертность и привлечёт внимание к
        экскурсиям
      </div>
      <UiButton
        :variant="UiButtonVariant.PRIMARY"
        :color-mode="UiButtonColorMode.NEUTRAL"
        :size="UiButtonSize.S"
        text="Поделиться фактом"
        class="btn"
        data-test="more-guide-spreadsheet"
        @clicked="goTo"
      >
      </UiButton>
    </div>
    <GuideMessageInfo :comment="guideInfo" />
  </div>
</template>

<script setup lang="ts">
  import { UiButton, UiButtonVariant, UiButtonColorMode, UiButtonSize } from '@experience/core-button-ui';

  import { type GuidesComments } from '@/shared/api/generated/api';
  import { type CityTagsAdvanced } from '@/shared/models/types';
  import GuideMessageInfo from '@/shared/ui/GuideMessageInfo.vue';

  const props = defineProps<{
    guideInfo: GuidesComments;
    sight: CityTagsAdvanced;
  }>();

  const goTo = () => {
    const guideId = props.guideInfo.guide?.id;
    const sightId = props.sight.id;
    window.open(
      `https://docs.google.com/forms/d/e/1FAIpQLSftkvScsSbJ66TONCjgOBebYPUM8bhprXGSL7mElEQOM1PKrQ/viewform?usp=pp_url&entry.1804679933=${String(guideId ?? '')}&entry.583654716=${String(sightId)}`,
      '_blank',
    );
  };
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as legacy-typography;
  @use '@experience/shared/dist/assets/adaptivity' as legacy-adaptivity;

  .container {
    padding: var(--alias-space-4) var(--alias-space-4) var(--alias-space-12) var(--alias-space-4);
    background-color: var(--alias-color-background-subtle);
    border-radius: var(--alias-radius-16);
  }

  .info {
    padding: var(--alias-space-8);
    background-color: var(--alias-color-background-default);
    border-radius: var(--alias-radius-12);
  }

  .title {
    @include legacy-typography.base-400-300-semi;

    @include legacy-adaptivity.tablet {
      max-width: 320px;
    }
  }

  .subtitle {
    max-width: 480px;
    margin-top: var(--alias-space-4);

    @include legacy-typography.base-300-300-regular;
  }

  .btn {
    margin-top: var(--alias-space-8);
  }

  .guide-info {
    margin: var(--alias-space-16) var(--alias-space-8) 0;
  }
</style>
